import { HttpClient, HttpEventType, HttpParams, HttpResponse } from '@angular/common/http';
import { inject, Service } from '@angular/core';
import { distinctUntilChanged, map, Observable } from 'rxjs';

const MAX_PROGRESS = 100;

export interface RequestData {
  readonly formData: FormData;
  readonly method?: 'POST' | 'PUT' | 'PATCH';
  readonly params?: HttpParams;
  readonly url: string;
}

export interface UploadEvent<T = unknown> {
  readonly progress: number;
  readonly response?: HttpResponse<T>;
}

@Service()
export class UploadService {
  readonly #http = inject(HttpClient);

  uploadFile<T>({ formData, method = 'POST', params, url }: RequestData): Observable<UploadEvent<T>> {
    return this.#http
      .request<T>(
      method,
      url,
      {
        body: formData,
        params,
        observe: 'events',
        reportProgress: true,
      },
    )
      .pipe(
        map((event) => {
          switch (event.type) {
            case HttpEventType.UploadProgress:
              return event.total ? { progress: Math.round(event.loaded / event.total * MAX_PROGRESS) } : { progress: 0 };

            case HttpEventType.Response:
              return { progress: MAX_PROGRESS, response: event };

            default:
              return { progress: 0 };
          }
        }),
        distinctUntilChanged(),
      );
  }
}
